import { ref } from 'vue';

export function useCreditManagement() {
  // 신용등급 목록
  const creditRatings = [
    'AAA',
    'AA+',
    'AA',
    'AA-',
    'A+',
    'A',
    'A-',
    'BBB+',
    'BBB',
    'BBB-',
    'BB+',
    'BB',
    'BB-',
    'B+',
    'B',
    'B-',
    'CCC+',
    'CCC',
    'CCC-',
    'CC',
    'C',
    'D',
  ];

  // 기본 크레딧 타입 매핑 (한글명)
  const defaultCreditTypeNames = {
    PUBLIC: '공사채',
    BANK: '은행채',
    CREDIT_FINANCE: '여전채',
    COMPANY: '회사채',
  };

  return {
    creditRatings,
    defaultCreditTypeNames,
  };
}

// 모달 관리 composable
export function useModalManagement() {
  const showCreateModal = ref(false);
  const showEditModal = ref(false);
  const selectedItem = ref(null);
  const isCreating = ref(false);
  const isUpdating = ref(false);
  const isDeleting = ref(false);

  const openCreateModal = (initialData = {}) => {
    selectedItem.value = null;
    showCreateModal.value = true;
    return initialData;
  };

  const closeCreateModal = () => {
    showCreateModal.value = false;
    selectedItem.value = null;
  };

  const openEditModal = (item) => {
    selectedItem.value = item;
    showEditModal.value = true;
    return item;
  };

  const closeEditModal = () => {
    showEditModal.value = false;
    selectedItem.value = null;
  };

  const confirmDelete = (item, message, onConfirm) => {
    if (confirm(message)) {
      onConfirm(item);
    }
  };

  return {
    // State
    showCreateModal,
    showEditModal,
    selectedItem,
    isCreating,
    isUpdating,
    isDeleting,

    // Methods
    openCreateModal,
    closeCreateModal,
    openEditModal,
    closeEditModal,
    confirmDelete,
  };
}

// 폼 검증 composable
export function useFormValidation() {
  const validateRequired = (fields, fieldNames) => {
    const missingFields = [];
    
    Object.entries(fields).forEach(([key, value]) => {
      if (fieldNames.includes(key) && (!value || value.toString().trim() === '')) {
        missingFields.push(key);
      }
    });

    return {
      isValid: missingFields.length === 0,
      missingFields,
    };
  };

  const showValidationError = (missingFields, fieldLabels = {}) => {
    const labels = missingFields.map(field => fieldLabels[field] || field).join(', ');
    alert(`${labels}은(는) 필수 입력 항목입니다.`);
  };

  return {
    validateRequired,
    showValidationError,
  };
}

// 에러 처리 composable
export function useErrorHandling() {
  const handleAsyncOperation = async (operation, loadingRef, errorMessage = '처리 중 오류가 발생했습니다.') => {
    loadingRef.value = true;
    try {
      const result = await operation();
      return result;
    } catch (error) {
      console.error(errorMessage, error);
      alert(error.message || errorMessage);
      throw error;
    } finally {
      loadingRef.value = false;
    }
  };

  return {
    handleAsyncOperation,
  };
} 